import { Button } from 'antd';
import styles from './recording.module.scss';
import recordCircle from '@assets/images/record-circle.svg';
import { useMemo } from 'react';

interface Props {
  stopRecording: () => void;
  timer: number;
  total: number;
  isGenerating: boolean;
}

const RecordingVoice = ({
  stopRecording,
  timer,
  total,
  isGenerating,
}: Props) => {
  const remaining = total - timer;

  // Format seconds to mm:ss
  const formatTime = (sec: number) => {
    const m = Math.floor(sec / 60);
    const s = sec % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };

  const progressWidth = useMemo(() => {
    return (timer / total) * 100;
  }, [timer]);

  return (
    <div className={styles.recording_card}>
      <div className={styles.recording_card_header}>
        <div className={styles.recording_card_status}>
          <img src={recordCircle} alt="record-icon" width={24} height={24} />
          <p>Recording in Progress</p>
        </div>
        <div className={styles.recording_card_timer}>
          <p>Remaining Time</p>
          <span>{formatTime(remaining)}</span>
        </div>
      </div>
      <div className={styles.recording_card_progressbar}>
        <div
          style={{ width: progressWidth }}
          className={styles.recording_card_progressThumb}
        />
      </div>
      <div className={styles.recording_card_progress_times}>
        <p>{formatTime(timer)}</p>
        <p>{formatTime(total)}</p>
      </div>
      <Button
        onClick={() => stopRecording()}
        className={styles.recording_card_button}>
        Stop recording
      </Button>
    </div>
  );
};

export default RecordingVoice;
